/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2021. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot re-loadable.
 */
import NoticesReducers from './Notices/reducers';
import AppealsReducers from './Appeals/reducers';
import VerificationsReducers from './Verifications/reducers';
import PersonsReducers from './Persons/reducers';
import DocumentServiceReducers from './DocumentService/reducers';
import CaseProgramsProductDeliveriesReducers from './CaseProgramsProductDeliveries/reducers';
import OnlineCategoriesReducers from './OnlineCategories/reducers';
import SubmittedApplicationsForVerificationReducers from './SubmittedApplicationsForVerification/reducers';
/**
 * Creates the main reducer which combines all the reducers from the modules
 * and any provided reducers supplied from the wrapping application.
 *
 * Provided reducers are ignored where there is a clash in naming.
 *
 * @namespace UAReduxReducers
 */

export default {
  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UANotices: NoticesReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAAppeals: AppealsReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAVerifications: VerificationsReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAPersons: PersonsReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UADocumentService: DocumentServiceReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UACaseProgramsProductDeliveries: CaseProgramsProductDeliveriesReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAOnlineCategories: OnlineCategoriesReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASubmittedApplicationsForVerification: SubmittedApplicationsForVerificationReducers.reducers
};